import { GET_ALL_ORDERS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

interface Response {
    success: boolean;
    pharma_orders: Order[];
    lab_orders: Order[];
}

export interface Order {
    pxid: string;
    order_id: string;
    created_at: string;
    paidAmount: number;
    orderName?: string;
}

export default (docIds: string, patientId: string): Promise<Response> => {
    return fetchWithRefresh(GET_ALL_ORDERS(docIds, patientId)).then((res) => res.json());
};
